import SearchSuggestionDialog from './SearchSuggestionDialog';

export default SearchSuggestionDialog;
